import {useMutation} from "@tanstack/react-query";

import {createRepresentativeMutationOptions} from "./create-representative.mutation-options";

export function useCreateRepresentative() {
  return useMutation(createRepresentativeMutationOptions());
}
